import { PrensaEngineCSSProp } from "@xprog/prensa/types"
import { PrensaEngine } from "@xprog/prensa"

export const Heading1 = PrensaEngine.styled('h1', {
  align: ['column', 'center', 'top'],
  display: 'flex',
  fontSize: '22px',
  fontWeight: 500,
  lineHeight: '28px',
  mt: '$0',
  width: '100%',
})

export const Heading2 = PrensaEngine.styled('h2', {
  alignItems: 'center',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '12px',
  mt: '$1',
  mb: '$3'
})

export const Heading3 = PrensaEngine.styled('h3', {
  alignItems: 'center',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '12px',
  mt: '$1',
  mb: '$1',

})

export const Heading4 = PrensaEngine.styled('h4', {
  alignItems: 'center',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  mt: '$0',
  mb: '$0'
})

export const Heading5 = PrensaEngine.styled('h5', {
  alignItems: 'center',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '15px',
  mt: '$0',
  mb: '$0'
})

export const MainDiv = PrensaEngine.styled('div', {
  align: ['column', 'center', 'top'],
  fontFamily: '$primary',
  width: '100%',
  my: '$15',
  '@lg': {
    my: '$10',
    // maxWidth: '940px'
  }
})

export const topBlockProps: PrensaEngineCSSProp = {
  align: ['column', 'center', 'top'],
  '@lg': {
    align: ['row', 'center', 'top'],
    width: '100%'
  }
}

export const middleBlockProps: PrensaEngineCSSProp = {
  align: ['column', 'center', 'top'],
  '@lg': {
    align: ['row', 'center', 'top'],
    mb: '$4',
    width: '80%'
  }
}

export const bottomBlockProps: PrensaEngineCSSProp = {
  align: ['column', 'center', 'top'],
  mb: '$18',
  width: '80%'
}

export const itemTopProps: PrensaEngineCSSProp = {
  align: ['column', 'center', 'top'],
  mb: '$6',
  '@lg': {
    mr: '$9',
  }
}

export const itemMiddleProps: PrensaEngineCSSProp = {
  align: ['column', 'center', 'top'],
  mb: '$6',
  minWidth: '250px !important',
  '@lg': {
    mr: '$8'
  }
}

export const itemBottomProps: PrensaEngineCSSProp = {
  align: ['column', 'center', 'top'],
  minWidth: '250px',
  mb: '$6',
  '@lg': {
    mb: '$8',
    mr: '$8'
  }
}

export const logoProps: PrensaEngineCSSProp = {
  align: ['column', 'center', 'top'],
  mb: '$10',
  mt: '$14'
}

export const logo2Props: PrensaEngineCSSProp = {
  align: ['column', 'center', 'top'],
  mb: '$10',
  mt: '$14'
}